<template>
  <div class="sn-bs-farm-detail">
    <div ref="lMap" class="sn-bs-farm-detail__map"></div>
    <bs-land-dialog
      ref="landDialog"
      v-model="visibilityLandDialog"
      :land-info="landInfo"
    ></bs-land-dialog>

    <div v-if="dialogVisible" id="newVideo" class="equiplayer videomonitor">
      <p class="title">
        <span class="pyc videotitle">{{ currentMarkerData.displayName }}</span>
        <span class="closebtn" onClick="window.layer.closeAll()"></span>
      </p>
      <div id="videomonitor">
        <camera-video
          ref="cameraVideoRef"
          :farmId="farmId"
          :url-option="currentMarkerData"
          :autoplay="true"
        ></camera-video>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { shAreaIds, reversePointfn } from "@/mixins/map/shTileLayer";
import { transformGcj02ToShcrood } from "@/mixins/map/about-map-common"; // Gcj-02 转 上海特殊偏移坐标系
import BsLandDialog from "@/views/bs/Farm/components/LandDialog";
import { farm } from "@/api/request/snkd.produce";
import { getPolygonCentroid, arrayDimensionalLength } from "@/utils/map/turf";
import cameraVideo from "@/views/bs/Farm/components/CameraVideo/CameraVideo.vue";
import { setImgUrl } from "@/utils";
import iotNewMixin from "../mixins/iot-new.js";
import iotNewMixinThird from "../mixins/iot-new-third.js";
import { mapTools } from "@/utils/mapTools";
const videoPoster = require("@/assets/images/bs/farm-detail/poster.jpg");
//计算marker位置大小 根据中心点，marker数量，序号 综合计算位置以及大小
var iconposArr = [
  [],
  [[12, 12]],
  [
    [24, 12],
    [0, 12],
  ],
  [
    [12, 24],
    [0, 0],
    [24, 0],
  ],
  [
    [24, 24],
    [0, 24],
    [0, 0],
    [24, 0],
  ],
]; //相对marker宽高为 24px
const unit = [0, 666.7, 66.67, 1];
export default {
  name: "BsFarmDetail",
  mixins: [iotNewMixin, iotNewMixinThird],
  data() {
    return {
      map: null,
      showShanghaiMap: false, // 是否显示为上海天地图 底图
      detailData: null,
      landPolygons: [],
      visibilityLandDialog: false,
      landInfo: {},
      videoPoster,
      dialogVisible: false,
    };
  },
  mounted() {
    this.initModule();
  },
  methods: {
    async initModule() {
      document.body.appendChild(this.$refs.lMap);
      await this.getMapController();
      // 是否显示上海天地图 显示条件：企业被监管+属于上海12个区内
      var farmInfo = JSON.parse(localStorage.getItem("FARMINFO"));
      var companyInfo = JSON.parse(localStorage.getItem("COMPANYINFO"));
      let isInShanghai = shAreaIds.includes(farmInfo.countyId); // 是否是要展示上海天地图的区域
      let companySupervisionFlag = Boolean(companyInfo.supervisionFlag); // 企业是否被监管开关 0：否 1：是
      this.showShanghaiMap = companySupervisionFlag && isInShanghai; // 是否显示为上海天地图 底图
      // 获取农场中心点
      const [mapCenter] = this.getLandListCenter(
        this.detailData.landAndPlantPlanListVOS
      );
      // 上海监管企业地块 path调整
      if (this.showShanghaiMap) {
        this.detailData.landAndPlantPlanListVOS.map((item) => {
          item.path =
            (item.shGisPath &&
              JSON.stringify(reversePointfn(JSON.parse(item.shGisPath)))) ||
            "";
          item.landCenterLat =
            (item.shGisPath && item.shGisLandCenterLat) || "";
          item.landCenterLng =
            (item.shGisPath && item.shGisLandCenterLng) || "";
        });
      }
      // 初始化地图
      this.map = await mapTools.initMap(
        this.$refs.lMap,
        mapCenter,
        this.showShanghaiMap
      );
      this.bindMapEvent();
      this.renderLandPolygon(this.detailData.landAndPlantPlanListVOS);
      this.renderCropMarker(this.detailData.landAndPlantPlanListVOS);
      try {
        await this._initIot();
        //新版物联网第三方设备
        await this.initThirdModule();
      } catch (error) {
        console.log(error);
      }
      // 农场缩放居中展示
      this.toMergeLandView();
      // 初始化 缩放等级样式
      let zoom = this.showShanghaiMap
        ? this.map.getZoom() + 10
        : this.map.getZoom();
      this.markerEditWithZoom(zoom);
    },
    async getMapController() {
      this.detailData = await farm.getMapService({
        companyId: this.companyId,
        farmId: this.farmId,
      });
    },

    getLandListCenter(landList) {
      let landCount = 0;
      let center = [39.942188, 116.372267];
      const allPath = landList.reduce((rings, landInfo) => {
        if (landInfo.path) {
          landCount++;
          rings = [...rings, JSON.parse(landInfo.path)];
        }
        return rings;
      }, []);
      if (landCount > 0) {
        const polygonBounds = L.polygon(allPath, {}).getBounds();
        center = polygonBounds.getCenter();
        center = [center.lat, center.lng];
      }
      return [center, landCount];
    },
    bindMapEvent() {
      this.map.on("click", () => {
        // 点击空白地图（点击位置不包含地块和作物图标）时，地图view 设置到默认状态
        // polygon，marker监听的click事件 会比这个慢触发 所以此处是拦截性 关闭已打开的所有弹框
        this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
      });
      this.map.on("zoomend", ({ target }) => {
        let zoom = this.showShanghaiMap ? target._zoom + 10 : target._zoom;
        this.markerEditWithZoom(zoom);
      });
    },

    renderLandPolygon(landList) {
      let hasLandIndex = 0;
      landList.forEach((landInfo) => {
        if (landInfo.path) {
          const landPath = JSON.parse(landInfo.path);
          const landPolygon = L.polygon(landPath, {
            color: landInfo.fillColor || "#64C3A4",
            fillColor: landInfo.fillColor || "#64C3A4",
            fillOpacity: 0.3,
            oldstroke: "#64C3A4",
            className: "polygonbox",
            weight: 2,
            attribution: {
              ...landInfo,
              index: hasLandIndex,
            },
          });
          hasLandIndex++;
          this.landPolygons.push(landPolygon);
          landPolygon.on("click", async ({ target }) => {
            // polygon，marker监听的click事件 会比map click事件 慢触发 再map监听click事件关闭已打开的所有弹框
            // 关闭弹框 watch到会地图归位，setView 是带动画的
            await new Promise((resolve) => {
              setTimeout(resolve, 500);
            });
            this.openLandDialog(target);
            this.toLandView(target);
            this.selectedLand(target);
          });
        }
      });
      this.map.addLayer(L.layerGroup(this.landPolygons));
    },
    renderCropMarker(landList) {
      const allCropMarker = [];
      landList.forEach((landInfo, index) => {
        let iconCenter = [
          landInfo.landCenterLat,
          landInfo.landCenterLng,
        ].filter((v) => !!v);
        if (landInfo.path) {
          let landPath = JSON.parse(landInfo.path);
          landPath =
            arrayDimensionalLength(landPath) >= 3 ? landPath : [landPath];
          // path hack 处理 turf 要求每个polygon 第一个点要跟最后一个点一样
          landPath.map((item) => {
            item.push(item.length - 1);
          });
          try {
            iconCenter = getPolygonCentroid(landPath);
          } catch (e) {
            landPath.push(landPath[0]);
            iconCenter = getPolygonCentroid(landPath);
          }
        }
        const cropIcons = (landInfo.cropList || [])
          .map((cropInfo) => setImgUrl(cropInfo.imgUrl, 48, 48, true))
          .slice(0, 4);
        const area =
          unit[landInfo["landAcreUnit"]] * parseFloat(landInfo["landAcre"]);
        const isSmallArea = area < 1333.5 ? true : false; //是否为小于2亩的小地块   //marker显示 特殊处理
        if (iconCenter.length > 1) {
          cropIcons.forEach((icon, j) => {
            const _icon = L.icon({
              iconUrl: icon,
              className: `m_${cropIcons.length}_${j + 1}${
                isSmallArea ? "_noc" : ""
              }`,
              iconSize: [24, 24],
              iconAnchor: iconposArr[cropIcons.length][j],
            });
            const _marker = L.marker(L.latLng(iconCenter), {
              icon: _icon,
              attribution: {
                ...landInfo,
                index,
              },
            });
            _marker.on("click", async ({ target }) => {
              // polygon，marker监听的click事件 会比map click事件 慢触发 再map监听click事件关闭已打开的所有弹框
              // 关闭弹框 watch到会地图归位，setView 是带动画的
              await new Promise((resolve) => {
                setTimeout(resolve, 500);
              });
              this.openLandDialog(target);
              this.toLandView(target);
              this.selectedLand(target);
            });
            allCropMarker.push(_marker);
          });
        }
      });
      this.map.addLayer(L.layerGroup(allCropMarker));
    },
    toMergeLandView() {
      if (this.landPolygons.length > 0) {
        const allBounds = [];
        this.landPolygons.forEach((polygon) => {
          const bounds = polygon.getBounds();
          allBounds.push([bounds._southWest.lat, bounds._southWest.lng]);
          allBounds.push([bounds._northEast.lat, bounds._northEast.lng]);
        });
        const mergeLandBounds = L.polygon(allBounds, {}).getBounds();
        const mergeLandZoom = this.map.getBoundsZoom(mergeLandBounds);
        const mergeLandCenter = mergeLandBounds.getCenter();
        // 向上偏移
        this.map.setView(mergeLandCenter, mergeLandZoom - 1);
      }
    },
    async openLandDialog(target) {
      this.landInfo = target.getAttribution();
      await this.$nextTick();
      this.$refs.landDialog.getLandBroadenInfoController();
      this.visibilityLandDialog = true;
    },
    async toLandView(target) {
      const attribution = target.getAttribution();
      const polygon = this.landPolygons[attribution.index];
      if (!polygon) return;
      const center = polygon.getCenter();
      var allzoom = this.map.getBoundsZoom(polygon.getBounds());
      this.map.setView(center, allzoom - 1);
      //监听move缩放事件 完成后地图下移
      await this.mapUpdateEvFn();
      //地图下移到弹框正下方
      var pxBounds = this.map.getPixelBounds();
      var boundY = pxBounds.max.y - pxBounds.min.y;
      let h = window.innerHeight;
      let th = (h - (h * 0.4 + 30) - 270) / 2 + 240;
      var bottomH = parseInt((boundY - 90) / 2 - th) * -1;
      this.map.panBy(L.point(0, bottomH));
    },
    mapUpdateEvFn() {
      var timer = null,
        timerplus = null;
      return new Promise((resolve) => {
        timerplus = setTimeout(() => {
          clearTimeout(timer);
          clearTimeout(timerplus);
          timerplus = null;
          resolve(false);
        }, 1000);
        this.map.once("moveend zoomend", () => {
          clearTimeout(timer);
          if (!timerplus) return;
          timer = setTimeout(function () {
            clearTimeout(timerplus);
            resolve(true);
          }, 100);
        });
      });
    },
    clearSelectedLand() {
      this.landPolygons.forEach((polygon) => {
        const $polygon = polygon._path;
        const fillColor = $polygon.getAttribute("fill");
        $polygon.setAttribute("stroke", fillColor);
        $polygon.setAttribute("stroke-width", "2");
      });
    },
    selectedLand(target) {
      this.clearSelectedLand();
      const attribution = target.getAttribution();
      const $polygon = this.landPolygons[attribution.index]._path;
      $polygon.setAttribute("stroke", "#ffffff");
      $polygon.setAttribute("stroke-width", "4");
    },
    markerEditWithZoom(zoom) {
      $(".leaflet-marker-pane")
        .get(0)
        .setAttribute(
          "class",
          `leaflet-pane leaflet-marker-pane zoom${parseInt(zoom)}`
        );
    },
    async OffsetAllPointerHander(list) {
      var pointerIndexs = [];
      var results = [];
      if (!list) return;
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        if (item.lat && item.lng) {
          //* 当是上海地图时,地块参照设计院坐标做加偏
          var result = await transformGcj02ToShcrood(
            item.lat,
            item.lng,
            this.$jsonp
          );
          results.push(result);
          pointerIndexs.push(i);
        }
      }
      results.map((pointer, index) => {
        if (list[pointerIndexs[index]].lat && list[pointerIndexs[index]].lng) {
          list[pointerIndexs[index]].lat = pointer[0];
          list[pointerIndexs[index]].lng = pointer[1];
        }
      });
      return;
    },
  },
  computed: {
    ...mapState(["farmId", "companyId"]),
  },
  watch: {
    visibilityLandDialog(val) {
      if (!val) {
        this.clearSelectedLand();
      }
    },
  },
  components: {
    BsLandDialog,
    cameraVideo,
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/style/bs/farm-detail/mapmarker.scss";

@include bs(farm-detail) {
  @include utils-full-box();
  @include e(map) {
    position: fixed;
    // 底部高度 - 头部高度
    top: calc(-301px + 95px);
    left: 0;
    width: 100%;
    height: calc(100% + (301px - 95px));
  }
}
</style>

<style lang="scss">
@import "~@/assets/style/bs/farm-detail/homemap.scss";
.layer_google {
  filter: saturate(1.3) contrast(120%) brightness(0.7);
}
.my-div-icon {
  .icon-inner {
    transform-origin: center center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .header {
      width: 100%;
      height: 68%;
      border-radius: 4px;
      border: 1px solid #fff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-image {
        height: 75%;
        border-radius: 0 !important;
      }
    }
    .footer {
      width: 65.6%;
      flex: 1;
      background: url("~@/assets/images/bs/farm-detail/marker_footer.png")
        no-repeat center center/100% 100%;
    }
    &.camera-icon {
      .header {
        background-color: #0091ff;
      }
    }
    &.gateway-icon {
      .header {
        background-color: #ff8a65;
      }
    }
    &.machine-icon {
      margin-top: -22px;
      .header {
        background-color: #4db7ad;
      }
    }
  }
  &.active {
    z-index: 9999 !important;
    .header {
      border: 2px solid #fff;
      background-color: #ed3333 !important;
    }
  }
}
</style>

<style>
@import "~@/assets/style/bs/farm-detail/QggcQDeviceList.css";
</style>
